import React, { useState } from "react"
import moment from "moment"
import MonthSelector from "./MonthSelector/MonthSelector"
import Days from "./Days/Days"
import styles from "./Drawer.scss"
import { start } from "repl"

interface IProps {
  closeDrawer: () => void
  setStartDate: (date: Date) => void
  setEndDate: (date: Date) => void
  startDate: Date
  endDate: Date
}

const DateRangePickerDrawer = ({
  closeDrawer,
  setStartDate,
  setEndDate,
  startDate,
  endDate
}: IProps) => {
  const currentDate = startDate || moment()
  const [month, setMonth] = useState<number>(currentDate.month())
  const [year, setYear] = useState<number>(currentDate.year())
  const [dateSelectionIndex, setdateSelectionIndex] = useState<boolean>(false)
  const firstDayOfMonth = moment()
    .month(month)
    .year(year)
    .startOf("month")
    .day()
  return (
    <div className={styles.container} id="drawer">
      <MonthSelector
        month={month}
        setMonth={setMonth}
        year={year}
        setYear={setYear}
      />
      <Days
        setdateSelectionIndex={setdateSelectionIndex}
        dateSelectionIndex={dateSelectionIndex}
        month={month}
        year={year}
        firstDayOfMonth={firstDayOfMonth}
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
      />
      <button onClick={closeDrawer}>Enregistrer</button>
    </div>
  )
}

export default DateRangePickerDrawer
